import { CSSProperties, PropsWithChildren, ReactElement, useState } from "react"
import { Contacts, ContactsType } from "~/shared/ui/components/Contacts"
import { Href, IconButton, MaterialIcon } from "~/shared/ui"
import { Button, Message } from "~/shared/ui/kit"
import { inv } from "~/shared/lib/utils"

export function LinkGroupWithContact(props: PropsWithChildren<{
	backgroundColor?: string,
	textColor?: string,
	items: ({
		title: string,
		href: string
	})[]
	contact?: ContactsType,
	icon?: string | ReactElement,
	outlinedIcon?: boolean
}>) {

	const [showLinks, setShowLinks] = useState(false)
	const [showContacts, setShowContacts] = useState(false)

	let icon = props.icon

	if (icon && typeof icon === "string") icon = <MaterialIcon name={icon} outlined={props.outlinedIcon} />

	return <div>
		<Message style={{ background: props.backgroundColor }} className="flex flex-col gap-[1rem]">
			<div className="flex items-center" style={{ color: props.textColor, borderBottom: showLinks ? "1px solid rgba(0, 0, 0, 0.125)" : undefined }}>
				{icon}
				<Button colorStyle="dark" className="button-without-focus"
						style={{
							justifyContent: "flex-start",
							flex: "1 0 auto",
							color: props.textColor
						}}
						onClick={() => setShowLinks(inv)}
						transparent borderless>{props.children}</Button>

				{props.contact && <>
					<div style={{
						height: "2.5rem",
						width: "2px",
						paddingLeft: "0.5rem",
						borderLeft: "1px solid #00000014"
					}}></div>
					<IconButton transparent borderless colorStyle="dark"
								style={{
									color: props.textColor,
									width: "2.5rem",
									height: "2.5rem",
									fontSize: "1.5rem",
									borderRadius: "0"
								}}
								icon="contact_support"
								onClick={() => setShowContacts(inv)} />
				</>}
			</div>
			{showLinks && <div className="flex flex-col gap-[1.5rem] p-[0_1rem_1rem_0]">
				{props.items.map(({ title, href }) => <Href key={href}
															href={href}
															style={{ paddingLeft: "1rem" }}>
					{title}
				</Href>)}
			</div>}
			{showContacts && <div><Contacts {...props.contact} style={{ '--contact-color': props.textColor } as CSSProperties}/></div>}
		</Message>
	</div>
}